import { GET } from '../annotations';
import { ascii, uint32 } from '../converters';
import { VirtualTap } from '../virtual-tap-server';

export class CloudService {
  private get cloudConfig() {
    if (!this.server.config.cloud) {
      this.server.config.cloud = {
        dataLog: {
          uploadPeriod: 0,
        },
      };
    }
    return this.server.config.cloud;
  }

  constructor(public server: VirtualTap) {
    // this.server.bindConfigToRoute({
    //     path: '/1024//12',
    //     converter: ascii,
    //     default: '',
    //     item: this.cloudConfig,
    //     key: 'url',
    //     get: true,
    //     put: true
    // });
    // this.server.bindConfigToRoute({
    //     path: '/1024//29',
    //     converter: ascii,
    //     default: '',
    //     item: this.cloudConfig,
    //     key: 'password',
    //     get: true,
    //     put: true
    // });
    this.server.bindConfigToRoute({
      path: '/1024//33',
      converter: uint32,
      default: 0,
      item: () => this.cloudConfig.dataLog || {},
      key: 'uploadPeriod',
      get: true,
      put: true,
    });
  }

  @GET({
    path: '/1024//61',
    responseType: ascii,
  })
  public getCloudBrokerServiceName() {
    return '';
  }
}
